import { render } from "./InfoSection.vue?vue&type=template&id=c824642e"
const script = {}

import "./InfoSection.vue?vue&type=style&index=0&id=c824642e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__